<template>
    <LoadEvents></LoadEvents>
</template>

<script>
import LoadEvents from '../../components/events/LoadEvents.vue';

export default {
    components: {
        LoadEvents
    }
}
</script>